
  const materiList = [
  {
    key:'python',
    title: 'python introduction',
    materi: [
      {
        title: "Materi 1: Menulis dan Menjalankan Program Pertama Python",
        content: `
          <p>Untuk menulis dan menjalankan program <strong>"Hello, World!"</strong> menggunakan Python, ikuti langkah-langkah berikut:</p>
          <ol>
            <li>Buat file <code>hello_world.py</code></li>
            <li>Tulis kode berikut:</li>
            <pre><code>print("Hello, World!")</code></pre>
            <li>Jalankan dengan <code>python hello_world.py</code></li>
          </ol>
          <p>Output: <code>Hello, World!</code></p>
        `,
      },
      {
        title: "Materi 2: Menggunakan Komentar Untuk Menjelaskan Kode",
        content: `
          <h3>Komentar dalam Python</h3>
          <p>Komentar tidak dieksekusi, hanya untuk penjelasan.</p>
          <ul>
            <li><strong>Satu baris:</strong> <code># Ini komentar</code></li>
            <li><strong>Multibaris:</strong> <code>''' ... '''</code></li>
          </ul>
        `,
      },
      {
        title: "Materi 3: Percabangan (if, else)",
        content: `<pre><code>if x > 10:\n  print("lebih dari 10")\nelse:\n  print("10 atau kurang")</code></pre>`,
      },
      {
        title: "Materi 4: Perulangan (loop)",
        content: `<pre><code>for i in range(5):\n  print(i)</code></pre>`,
      },
      {
        title: "Materi 5: Fungsi dan Modularisasi",
        content: `<pre><code>def sapa(nama):\n  print("Halo", nama)\n\nsapa("Budi")</code></pre>`,
      },
    ],
  },
  {
    key: 'html',
    title:'HTML',
    materi: [
      {
        title: "Materi 1: Struktur Dasar HTML",
        content: `
          <pre><code>&lt;!DOCTYPE html&gt;
&lt;html&gt;
  &lt;head&gt;
    &lt;title&gt;Judul Halaman&lt;/title&gt;
  &lt;/head&gt;
  &lt;body&gt;
    &lt;h1&gt;Hello World&lt;/h1&gt;
  &lt;/body&gt;
&lt;/html&gt;
</code></pre>`,
      },
      {
        title: "Materi 2: Heading dan Paragraf",
        content: `
          <pre><code>&lt;h1&gt;Judul Utama&lt;/h1&gt;
&lt;p&gt;Ini paragraf pertama&lt;/p&gt;</code></pre>`,
      },
      {
        title: "Materi 3: List dan Link",
        content: `
          <pre><code>&lt;ul&gt;
  &lt;li&gt;Item 1&lt;/li&gt;
  &lt;li&gt;Item 2&lt;/li&gt;
&lt;/ul&gt;

&lt;a href="https://google.com"&gt;Google&lt;/a&gt;</code></pre>`,
      },
    ],
  },
];


 let currentBab = 0;
let currentIndex = 0;



export function getMateriSekarang() {
  return materiList[currentBab].materi[currentIndex];
}

export function berikutnya() {
  if (currentIndex < materiList[currentBab].materi.length - 1) {
    currentIndex++;
  }
  return getMateriSekarang();
}

export function sebelumnya() {
  if (currentIndex > 0) {
    currentIndex--;
  }
  return getMateriSekarang();
}

export function pindahBab(babKeyOrIndex) {
  if (typeof babKeyOrIndex === "string") {
    // cari bab berdasarkan key
    const foundIndex = materiList.findIndex((bab) => bab.key === babKeyOrIndex);
    if (foundIndex !== -1) {
      currentBab = foundIndex;
    }
  } else if (typeof babKeyOrIndex === "number") {
    // langsung pakai index
    if (babKeyOrIndex >= 0 && babKeyOrIndex < materiList.length) {
      currentBab = babKeyOrIndex;
    }
  }
  currentIndex = 0; // reset ke materi pertama tiap bab
  return getMateriSekarang();
}

  // Tampilkan materi pertama saat halaman dimuat
  //window.onload = tampilkanMateri;

